import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actionTypes from '../../redux/actionTypes';
import { Redirect } from 'react-router-dom';
import PaymentName from './components/PaymentName';
import PaymentAmount from './components/PaymentAmount';
import Card from '../../shared/credit-card/Card';
import StopRecurringConfirmationPopup from '../../payment/StopRecurringConfirmationPopup';
import currency from '../../shared/currencyFormatter';

class ModifyRecurringPaymentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasFocused: false,
      originalPayment: null,
      payment: null,
      modal: {
        active: false
      },
      shouldRedirect: false,
      lastUpdateTime: 0
    };
    this._isMounted = true;
    this.updateTimeout = null;
  }

  componentDidMount() {
    this.props.init();
  }

  componentWillReceiveProps(nextProps) {
    const paymentId = window.location.hash.split('/').pop();

    if (nextProps.scheduledPayments) {
      const found = nextProps.scheduledPayments.scheduled.find(
        payment => payment.id.toString() === paymentId
      );

      // Set originalPayment once when component mounts
      if (!this.state.originalPayment && found) {
        const formattedOriginalPayment = { 
          ...found, 
          amount: found.amount ? currency.dollarPad(found.amount.toString()) : found.amount
        };
        this.setState({ originalPayment: formattedOriginalPayment });
      }

      // Only update payment if:
      // 1. We don't have a payment in state yet, or
      // 2. The payment ID in props is different from current payment ID
      const shouldUpdatePayment = !this.state.payment || 
        (found && this.state.payment.id !== found.id);
      
      if (shouldUpdatePayment) {
        const paymentData = nextProps.payment || found;
        const formattedPayment = { 
          ...paymentData, 
          amount: paymentData && paymentData.amount ? currency.dollarPad(paymentData.amount.toString()) : ""
        };
        this.setState({ 
          payment: formattedPayment
        });
      }
    }
  }
  
  // Add componentWillUnmount to prevent state updates after unmount
  componentWillUnmount() {
    this._isMounted = false;
  }

  updateState(updates) {
    // Only update the state if the values have actually changed
    const shouldUpdate = Object.keys(updates).some(key => {
      return this.state.payment[key] !== updates[key];
    });
    
    if (shouldUpdate) {
      this.setState(prevState => ({
        payment: {
          ...prevState.payment,
          ...updates
        }
      }));
    }
  }

  setNameInput(ref) {
    if (!this.state.hasFocused && ref) {
      this.setState({ hasFocused: true });
      ref.focus();
    }
  }

  canUpdate(payment, original) {
    return (
      payment &&
      payment.amount &&
      payment.name &&
      !(
        payment.name === original.name &&
        parseFloat(payment.amount) === parseFloat(original.amount)
      )
    );
  }

  closeRemoveModal() {
    this.setState({ modal: { active: false } });
  }

  removePaymentClicked() {
    this.props.removePayment(this.state.payment);
    this.closeRemoveModal();
    this.setState({ shouldRedirect: true });
  }

  render() {
    if (!this.state.payment) {
      return null;
    }

    if (this.state.shouldRedirect) {
      return <Redirect to={'/payment/summary/payments'} />;
    }

    const { review } = this.props;
    const { payment, originalPayment } = this.state;
    const canUpdate = this.canUpdate(payment, originalPayment);

    return (
      <div className="modify recurring">
        <StopRecurringConfirmationPopup
          active={this.state.modal.active}
          paymentName={this.state.payment.name}
          cancel={() => this.closeRemoveModal()}
          confirm={() => this.removePaymentClicked()}
        />
        <div className="title-toggle section">
          <h2 className="title">Modify Recurring Payment</h2>
        </div>
        <PaymentName
          name={payment.name}
          updateState={state => this.updateState(state)}
          inputRef={ref => this.setNameInput(ref)}
        />
        <PaymentAmount
          amount={payment.amount}
          updateState={state => this.updateState(state)}
        />
        <div className="schedule section visible">
          <h3>Payment Info</h3>
          <Card {...payment} />
          <div className="occurrence-text">
            Your recurring payment is scheduled for the{' '}
            <span className="date">{payment.every} of the month.</span>
          </div>
        </div>

        <div className="tools section">
          <div className="secondary">
            <button
              className="button delete"
              onClick={() => {
                this.setState({ modal: { active: true } });
              }}
            >
              Remove Payment
            </button>
          </div>
          <div className="primary">
            <button className="button cancel" onClick={this.props.cancel}>
              Cancel
            </button>
            <button
              className="button primary pay"
              onClick={() => review({ ...payment, selectedCard: payment })}
              disabled={!canUpdate}
            >
              Update
            </button>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    scheduledPayments: state.scheduledPayments
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    init() {
      dispatch({ type: actionTypes.SCHEDULED_PAYMENTS_LOADING });
    },
    removePayment(payment) {
      dispatch({
        type: actionTypes.SCHEDULED_PAYMENTS_DELETING,
        data: payment
      });
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModifyRecurringPaymentForm);
